export default __webpack_public_path__ + "img/cursor-owl-carousel.044c1e6c.svg";